import './App.css';
import Card from './components/Card/Card.js';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Card/>
      </header>
      <p>This Application consumes data from <a href="https://catfact.ninja/">Cat Facts API</a></p>
    </div>
  );
}

export default App;
